import { PDFViewer } from '@react-pdf/renderer';
import React, { useState, useEffect } from 'react';
import VoucherDocument from '../VoucherDocument/VoucherDocument';
import { TemplateRenderer, useTemplateOrFallback } from 'PDF/TemplateEngine';
import { useTenantData } from 'providers/Tenant/TenantDataProvider';

import { getImagesVoucher } from '../../../api/attentionVoucher';
import useAuth from '../../../hooks/useAuth';
import useSignatureUrls from 'hooks/useSignatureUrls';

function Preview(props) {
  const { voucher } = props;
  const [images, setImages] = useState([]);
  const { user = { fullname: 'nombre especialista' } } = useAuth();
  const { tenant } = useTenantData() || {};
  const { template, loading } = useTemplateOrFallback('comprobante');
  const { urls: signatureUrls, ready: signaturesReady } = useSignatureUrls({
    specialist_signature: voucher?.specialist_signature,
    recepcionist_signature: voucher?.recepcionist_signature,
  });

  useEffect(() => {
    getImagesVoucher(voucher.id).then((result) => {
      setImages(result.images);
    });
  }, [voucher.id]);

  if (!signaturesReady) return <div>Cargando firmas...</div>;

  const useTemplate = !loading && template?.id;
  const voucherWithSignatures = {
    ...voucher,
    specialist_signature: signatureUrls.specialist_signature,
    recepcionist_signature: signatureUrls.recepcionist_signature,
  };
  const data = { ...voucherWithSignatures, images };

  return (
    <PDFViewer style={{ width: '80vw', height: '80vh ' }} showToolbar={false}>
      {useTemplate ? (
        <TemplateRenderer template={template} data={data} config={tenant || {}} />
      ) : (
        <VoucherDocument voucher={voucherWithSignatures} user={user} images={images} />
      )}
    </PDFViewer>
  );
}




export default Preview;
